import { format, getDay } from "date-fns";

export type RecurrenceType =
  | "doesnt-repeat"
  | "daily"
  | "weekly"
  | "monthly-by-day"
  | "monthly-by-date"
  | "annually"
  | "weekdays"
  | "custom";

export type CustomRecurrence = {
  interval: number;
  unit: "day" | "week" | "month" | "year";
  endType: "never" | "on" | "after";
  endDate?: Date;
  occurrences?: number;
  weekdays?: number[];
};

export const getRecurrenceText = (
  type: RecurrenceType,
  custom?: CustomRecurrence,
  date?: Date
) => {
  if (!date) date = new Date();

  switch (type) {
    case "doesnt-repeat":
      return "Doesn't repeat";
    case "daily":
      return "Daily";
    case "weekly":
      return `Weekly on ${format(date, "EEEE")}`;
    case "monthly-by-day": {
      const weekNum = Math.ceil(date.getDate() / 7);
      const weekText =
        weekNum === 1
          ? "first"
          : weekNum === 2
          ? "second"
          : weekNum === 3
          ? "third"
          : "fourth";
      return `Monthly on the ${weekText} ${format(date, "EEEE")}`;
    }
    case "monthly-by-date":
      return `Monthly on day ${format(date, "d")}`;
    case "annually":
      return `Annually on ${format(date, "MMMM d")}`;
    case "weekdays":
      return "Every weekday (Monday to Friday)";
    case "custom": {
      if (!custom) return "Custom";
      const unitText = custom.interval === 1 ? custom.unit : `${custom.unit}s`;
      let text = `Every ${custom.interval} ${unitText}`;
      if (custom.endType === "on" && custom.endDate) {
        text += `, until ${format(custom.endDate, "MMMM d, yyyy")}`;
      } else if (custom.endType === "after" && custom.occurrences) {
        text += `, ${custom.occurrences} times`;
      }
      return text;
    }
    default:
      return "Unknown recurrence";
  }
};
